<h3 *ngIf="subtitle == typeIrops.CANCELLED">{{ "srIrops.weTriedRearrangeYourItinerary" | translate }}</h3>
<h3 *ngIf="subtitle == typeIrops.DELAYED || subtitle == typeIrops.EARLY ">{{ "srIrops.thanksFor" | translate }}</h3>